import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../pages/HomePage.vue";

const routes = [
  { path: "/", name: "home", component: HomePage },
  {
    path: "/mentions-legales",
    name: "mentions-legales",
    // Chargées à la demande : elles ne pèsent pas sur le bundle de la page d'accueil.
    component: () => import("../pages/MentionsLegalesPage.vue"),
    meta: { title: "Mentions légales — Zarafa Consulting" },
  },
  {
    path: "/confidentialite",
    name: "confidentialite",
    component: () => import("../pages/ConfidentialitePage.vue"),
    meta: { title: "Politique de confidentialité — Zarafa Consulting" },
  },
  // Toute URL inconnue renvoie vers l'accueil plutôt que sur une page blanche.
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 80 };
    return { top: 0 };
  },
});

const DEFAULT_TITLE = "Zarafa Consulting — développement d'applications web";

router.afterEach((to) => {
  document.title = to.meta?.title || DEFAULT_TITLE;
});

export default router;
